export default __webpack_public_path__ + "static/shutterstock_10-0e757b49020c928bd5dfb3f02e3a96d8.jpg";